import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import { translateArrayToUrlParamString } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class AlertsService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    /**
     * Creates a new alert.
     *
     * @param alertType: Alert type.
     * @param objectType: Object Type.
     * @param objectId: Object ID.
     * @param params: Params required to create the alert, including the metrics, value, and operator.
     */
    createAlert(alertType, objectType, objectId, params) {
        const urlParams = { alertType, objectType };
        const postParams = {
            objectId,
            ...params,
        };
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT_COLLECTION, urlParams);
        return this.ajaxService.postFormEncodedDataObserveBody(url, postParams);
    }
    /**
     * Deletes an Alert.
     *
     * @param alertType: Alert type.
     * @param objectType: Object Type.
     * @param alertId: id of the alert to be deleted.
     */
    deleteAlert(alertType, objectType, alertId) {
        const urlParams = { alertType, objectType, alertId };
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT, urlParams);
        return this.ajaxService.deleteDataObserveBody(url);
    }
    /**
     * Returns a list of alerts for an object.
     *
     * @param objectType: Object Type.
     * @param objectId: Object ID.
     */
    getAlertsForObject(objectType, objectId) {
        const urlParams = {
            objectType,
            objectId,
        };
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT_GROUP, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    /**
     * Deletes all alerts for a given object.
     *
     * @param objectType: Type the underlying object of the alert group
     * @param objectId: ID of the underlying object of the alert group
     */
    deleteAlertsForObject(objectType, objectId) {
        const urlParams = {
            objectType,
            objectId,
        };
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT_GROUP, urlParams);
        return this.ajaxService.deleteDataObserveBody(url);
    }
    /**
     * Returns the response from AlertGroupCollectionView.
     *
     * @param getParams: params containing filters for the alerts list.
     */
    getAlertGroups(getParams) {
        const url = this.urlsService.ALERTS.ALERT_GROUP_COLLECTION;
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    getAlertMessages(params) {
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT_MESSAGE_COLLECTION);
        return this.ajaxService.getDataObserveBody(url, params);
    }
    putAlertMessages(messageIds) {
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT_MESSAGE_COLLECTION);
        const params = { messageIds: translateArrayToUrlParamString(messageIds) };
        return this.ajaxService.putDataObserveBody(url, params);
    }
    putAlertMessage(messageId) {
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT_MESSAGE, { messageId });
        return this.ajaxService.putDataObserveBody(url, {});
    }
    /**
     * Disables an alert.
     *
     * @param alertType: Alert type.
     * @param objectType: Object Type.
     * @param objectId: Object ID.
     */
    disableAlert(alertType, objectType, alertId) {
        const urlParams = { alertType, objectType, alertId };
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.DISABLE_ALERT, urlParams);
        return this.ajaxService.postFormEncodedDataObserveBody(url, {});
    }
    /**
     * Enables an alert.
     *
     * @param disabledAlertPreferenceId: Preference Id of the disbaled alert
     */
    enableAlert(disabledAlertPreferenceId) {
        const urlParams = { disabledAlertPreferenceId };
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ENABLE_ALERT, urlParams);
        return this.ajaxService.deleteDataObserveBody(url);
    }
    /**
     * Get a single alert data.
     *
     * @param alertType: Alert type.
     * @param objectType: Object Type.
     * @param objectId: Object ID.
     */
    getAlert(alertType, objectType, alertId) {
        const urlParams = { alertType, objectType, alertId };
        const url = this.urlsService.getUrl(this.urlsService.ALERTS.ALERT, urlParams);
        return this.ajaxService.getDataObserveBody(url, {});
    }
}
AlertsService.ɵfac = function AlertsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AlertsService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
AlertsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: AlertsService, factory: AlertsService.ɵfac, providedIn: 'root' });
